/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.search-btn i').on('click', function(){
          $('.search-btn').toggleClass('active');
        });

        $(document).on('mouseenter', '.hovers-container .hover-el', function(){
          $('.hovers-container').addClass('hover');
        });
        $(document).on('mouseleave', '.hovers-container .hover-el', function(){
          $('.hovers-container').removeClass('hover');
        });

        // products & brochures filtering
        var activeProductCat = $('.products-categories li a.active-cat');

      	$(document).on('click', '.products-categories li a', function() {
      		activeProductCat.removeClass('active-cat');
      		category = $(this).attr('data-category');
      		sendFilterAjax(category, 'products');
      		activeProductCat = $(this);
      		activeProductCat.addClass('active-cat');
      	});

        var activeBrochuresCat = $('.brochures-categories li a.active-cat');

      	$(document).on('click', '.brochures-categories li a', function() {
      		activeBrochuresCat.removeClass('active-cat');
      		category = $(this).attr('data-category');
      		sendFilterAjax(category, 'brochures');
      		activeBrochuresCat = $(this);
      		activeBrochuresCat.addClass('active-cat');
      	});

        $(document).on('click', '#videos-list .video-link', function(evt){
          evt.preventDefault();
          var youtubeLink = $(this).attr('data-link'),
              videoTitle = $(this).find('h3').html();

          $('#videoModal .video-title').html(videoTitle);
          $('#videoModal .video-embed').attr('src', 'https://www.youtube.com/embed/' + youtubeLink);

        });

        $('#hamburger').click(function(){
          $(this).toggleClass('open');
          $('body').toggleClass('menu-open');
        });

      },
      finalize: function() {
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        var productSlider = new Swiper ('#product-slider .swiper-container', {
          pagination: '.swiper-pagination',
          nextButton: '.swiper-nav .next',
          prevButton: '.swiper-nav .prev',
          slidesPerView: 'auto',
          paginationClickable: true,
          autoplay: 4000
        });

        // Smooth scroll
        $(function() {
          var headerHeight = $('header.top-bar').height();
          $('a[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
              if (target.length) {
                $('html, body').animate({
                  scrollTop: target.offset().top - headerHeight
                }, 1000);
                return false;
              }
            }
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
